import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 5H1v18h18v-2H3V5zm20-4H5v18h18V1zm-2 16H7V3h14v14zm-10-2h6V9h-4V7h4V5h-6v10zm2-4h2v2h-2v-2z"
}), 'Filter6Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Filter6Sharp.js
// module id = 3603
// module chunks = 2